import type {
  RuleEditorValues,
  SiteSeparationRuleType,
} from './RuleEditor.types';
import type { TestRuleValues } from './TestRuleSidePanelContent.helpers';
import { RULE_TYPE_OPTIONS } from './ruleEditorValues';

export type RuleEditorMode = 'edit' | 'test';
export type TestOpenSource = 'editor' | 'table';

type RuleTypeOption = (typeof RULE_TYPE_OPTIONS)[number] & {
  disabled?: boolean;
  tooltip?: string;
};

export const getInitialMode = (initialMode?: RuleEditorMode): RuleEditorMode =>
  initialMode ?? 'edit';

export const getInitialTestOpenSource = (
  initialMode?: RuleEditorMode,
): TestOpenSource => (initialMode === 'test' ? 'table' : 'editor');

export const getSidePanelTitle = (
  mode: RuleEditorMode,
  isAddMode: boolean,
): string => {
  if (mode === 'test') {
    return 'Test rule expression';
  }

  return isAddMode ? 'New rule' : 'Edit rule';
};

export const getRuleTypeOptions = (
  selectedType: SiteSeparationRuleType,
  hasRoutingSwitchingRule: boolean,
): RuleTypeOption[] => {
  const disableRoutingSwitching =
    hasRoutingSwitchingRule && selectedType !== 'routingSwitching';

  return RULE_TYPE_OPTIONS.map((option) =>
    option.value === 'routingSwitching' && disableRoutingSwitching
      ? {
          ...option,
          disabled: true,
          tooltip: 'Only one Routing & switching rule can be added.',
        }
      : option,
  );
};

export const getRuleValuesWithAppliedTestValues = (
  currentValues: RuleEditorValues,
  testValues: TestRuleValues,
): RuleEditorValues => {
  // cloudResourceTag carries tagNames instead of regex/siteName.
  if (testValues.type === 'cloudResourceTag') {
    return {
      ...currentValues,
      tagNames: testValues.tagNames,
      transformation: testValues.transformation,
      applyToCloudInstances: testValues.applyToCloudInstances,
    };
  }

  return {
    ...currentValues,
    regex: testValues.regex,
    siteName: testValues.siteName,
    transformation: testValues.transformation,
    applyToCloudInstances:
      testValues.type === 'regexCloudResourceId'
        ? testValues.applyToCloudInstances
        : currentValues.applyToCloudInstances,
  };
};
